import { auth, defaultIMG, imgBaseURL } from "helper/Utility"
import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { currencyText } from "helper/Constant"

const ProductBox = ({ item }) => {
    return (
        <>
            <div className="product-boxes">
                <Link to={`/product-details/${item?._id}`} className="nn_homproductctn">
                    <img alt="" src={item?.gallery?.length > 0 ? imgBaseURL() + item?.gallery[0] : defaultIMG} />
                </Link>
                <div className="product-boxes_inner">
                    <h2>
                        <Link to={`/product-details/${item?._id}`} className="product-title">
                            {" "}
                            {item?.title}
                        </Link>
                    </h2>
                    {item?.location && (
                        <p>
                            <i className="fa fa-location-dot"></i> {item?.location}
                        </p>
                    )}
                    <p className="price-products">
                        {currencyText} {item?.price}
                    </p>
                </div>
            </div>
        </>
    )
}

export default ProductBox
